<template>
  <div class="gallery-container" :id="id">

    <!-- <h1 class="title">
      Gallery
    </h1> -->

    <div-container v-if="id === 'photos-official'" style="text-align:center;">
      <h1 class="title"><a :href="navInstagram.path" target="_blank"><i class="fa fa-instagram" style="font-size:1.4em;vertical-align:middle;margin-bottom:5px;"></i> / {{ navInstagram.title }}</a></h1>
    </div-container>
    <div-container v-else style="text-align:center;">
      <h1 class="title"><a :href="navInstagramHashtag.path" target="_blank">{{ navInstagramHashtag.title }}</a></h1>
    </div-container>
    <!-- <page-subheader v-else :title="navInstagramHashtag.title" style="margin-left:8px;margin-right:8px;"></page-subheader> -->

    <div-container>
      <div-columns column-num="is-11" padding-top="1rem">
        <div class="masonry-container columns is-gapless is-centered is-multiline is-flex-mobile" id="masonry-container" v-infinite-scroll="loadMore" infinite-scroll-disabled="itemsLoading" infinite-scroll-distance="-1">

          <div class="column is-4 is-6-mobile" v-for="(item, index) in items" data-aos="fade-up" data-aos-once="true" v-if="index !== 8 || isDesktop">
            <a :href="item.url3" target="_blank" @click="($event) => onItemClick($event, item)">
              <div class="focus-image-wrapper">
                <figure class="image square" style="" :style="[{
                  'background-image': 'url(' + (item.image && item.image.path ? item.image.path : (item.type === 'VIDEO' ? item.url2 : item.url)) + ')'
                  }, styleIE]">
                </figure>
              </div>
            </a>
          </div>

          <div v-if="!itemsLoading && !error && items.length <= 0">
            <h3 style="padding-top:3rem;color:#aaaaaa;">(not available yet)</h3>
          </div>
        </div>

        <!-- <div class="masonry-container" id="masonry-container" v-masonry transition-duration="0.0s" item-selector=".masonry-item" data-masonry-options="{ 'isFitWidth': true }" v-infinite-scroll="loadMore" infinite-scroll-disabled="itemsLoading" infinite-scroll-distance="-1">

          <div v-masonry-tile class="masonry-item" v-for="(image, index) in items" data-aos="slide-up" data-aos-once="true" data-aos-duration="1000" data-aos-offset="0">
            <a :href="image.link" target="_blank">
              <div class="card">
                <div class="card-image">
                  <figure class="image">
                    <img :src="parseInstagramImageLink(image.images.standard_resolution.url)" alt="Image">
                  </figure>
                </div>
              </div>
            </a>
          </div>
        </div> -->

        <!-- <div class="load-more">
          <div class="button" v-if="!itemsEnded" @click="loadMore()" :class="{ 'is-loading': itemsLoading }"></div>
          <div class="ended" v-if="itemsEnded" data-aos="slide-up" data-aos-once="true" data-aos-duration="1000">browse more at<br class="is-hidden-desktop" />&nbsp;&nbsp;<a  :href="navInstagram.path" target="_blank"><i class="fa fa-2x fa-instagram" style="vertical-align:middle;"></i> / {{ navInstagram.title }}</a></div>
        </div> -->

        <div class="control notification is-danger" v-if="error">
          <button class="delete" @click="error = undefined"></button>
          <p v-html="error">
          </p>
        </div>
      </div-columns>
    </div-container>

    <div-container v-if="id === 'photos-trending'" style="text-align:center;">
      <h4 class="button is-primary">
        <a :href="navInstagramHashtag.path" target="_blank">View More on Instagram</a>
      </h4>
    </div-container>

    <div-container v-else-if="id === 'photos-official'" style="text-align:center;">
      <h4 class="button is-primary">
        <a :href="navInstagram.path" target="_blank">View More on Instagram</a>
      </h4>
    </div-container>

    <div-container v-else style="text-align:center;">
      <!-- <h4 class="button is-primary">
        <a href="/photos">View All</a>
      </h4> -->
      <h4 class="button is-primary">
        <a :href="'/photos'">View All</a>
      </h4>
    </div-container>

  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/Site'
import DivContainer from '@/components/DivContainer'
import DivColumns from '@/components/DivColumns'
import PageSubheader from '@/components/PageSubheader'
// import Instafetch from '@/controllers/Instafetch'

export default {
  name: 'masonry-instagram',
  components: {
    DivContainer,
    DivColumns,
    PageSubheader
  },
  props: ['id'],
  data () {
    return {
      isDesktop: true,
      isIE: EventBus.detectIE(),
      styleIE: {},
      itemsCache: [],
      items: [],
      itemsLoading: true,
      itemsEnded: false,
      itemsHasNext: false,
      itemsHasNextToken: undefined,
      itemsMax: 9,
      error: undefined,
      navInstagram: EventBus._data._navInstagram,
      navInstagramHashtag: EventBus._data._navInstagramHashtag
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    // refresh masonry
    this.refresh()

    // var callbackInstagram = function (data) {
    //   console.log(data)
    // }
    // var fetcher = new Instafetch('15794449.23ef492.b92d5f8be35a469ebfaeceb6b259b3d7')
    // // var fetcher = new Instafetch('23ef492f142645d7892ae61d3697f3a6')
    // fetcher.fetch({
    //   // user: 15794449,
    //   tag: 'adamlobotv',
    //   limit: 88,
    //   callback: callbackInstagram
    //   // params: '9gagBlock'
    // })

    // fix for IE where images are not displayed
    if (this.isIE) {
      var minHeight = '300px'
      if (!this.isDesktop) {
        minHeight = '150px'
      }
      this.styleIE = {
        minHeight: minHeight
      }
    }
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    parseInstagramImageLink (link) {
      var linkOut = link.replace(/(https*:\/\/.*\/.*)\/.*\/.*\/.*(\/.*)/g, '$1$2')
      return linkOut
    },
    getItems: function (onComplete) {
      this.itemsLoading = true

      // if (this.id && this.id === 'photos-official') {
      // Site.instagramUser('1766012752.1677ed0.e930de6bc89c44b494d75da69dca6a3a', this.itemsHasNextToken)
      // .then(data => {
      //   // console.log('get gallery')
      //   // console.log(data)
      //   this.itemsHasNext = data.hasNextPage
      //   this.itemsHasNextToken = data.maxId
      //   var items = data.items
      //   onComplete(items)
      //   this.itemsLoading = false
      // })
      Site.instagramApi(24, this.itemsHasNextToken)
      .then(response => {
        // console.log('get gallery')
        // console.log(data)
        var items = response.data
        onComplete(items)
        let hasNext = (response.data && response.data.length > 0)
        this.itemsHasNext = hasNext
        this.itemsHasNextToken = hasNext ? this.items.length : 0
        this.itemsLoading = false
      })
      .catch(error => {
        // console.log('invalid get gallery', error)
        this.items = []
        // this.error = error.error
        this.error = error.error
        this.error = 'Unable to load, please kindly visit our Instagram account <a href="' + this.navInstagram.path + '" target="_blank">here</a>.'
        this.itemsLoading = false
      })
      // } else {
      //   console.log('-- getting hash --')
      //   console.log(this.navInstagramHashtag.title.replace('#', ''))
      //   Site.instagramTag(this.navInstagramHashtag.title.replace('#', ''), this.itemsHasNextToken)
      //   .then(data => {
      //     console.log('get gallery tag')
      //     console.log(data)
      //     this.itemsHasNext = false
      //     this.itemsHasNextToken = false
      //     var items = data.graphql.hashtag.edge_hashtag_to_media.edges // this one differ from user photos
      //     // var items = data.tag.top_posts.nodes // this one differ from user photos
      //     var newItems = []
      //     for (var i = 0; i < items.length; i++) {
      //       var item = items[i].node
      //       if (item.display_url) {
      //         item.images = {
      //           standard_resolution: {
      //             // url: this.parseInstagramImageLink(item.display_url)
      //             url: item.display_url
      //           }
      //         }
      //         item.link = 'https://www.instagram.com/p/' + item.shortcode
      //         // console.log(item)
      //       }
      //       newItems.push(item)
      //     }
      //     onComplete(newItems)
      //     this.itemsLoading = false
      //   })
      //   .catch(error => {
      //     // console.log('invalid get gallery', error)
      //     this.items = []
      //     // this.error = error.error
      //     this.error = error.error
      //     this.error = 'Unable to load, please kindly visit our Instagram account <a href="' + this.navInstagram.path + '" target="_blank">here</a>.'
      //     this.itemsLoading = false
      //   })
      // }
    },
    refresh: function () {
      this.getItems((items) => {
        if (items && items.length > 0) {
          var limitItems = []
          for (var i = 0; i < this.itemsMax; i++) {
            if (i < items.length) {
              limitItems.push(items[i])
            }
          }
          this.items = limitItems
        } else {
          this.items = []
        }
      })
    },
    loadMore: function () {
      // return if exceed (showcase purpose)
      if (!this.itemsHasNext) {
        this.itemsEnded = true
        this.$emit('onItemsEnded', {})
        return
      }

      if (!this.itemsEnded) {
        this.getItems(function (items) {
          this.items = this.items.concat(items)
          if (this.items.length > this.itemsMax) {
            this.items = this.items.slice(0, this.itemsMax)
            this.itemsEnded = true
            this.$emit('onItemsEnded', {})
          }
        }.bind(this))
      }
    },
    onItemClick: function ($event, item) {
      $event.preventDefault()
      this.$emit('onItemClick', item)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// main gallery

.gallery-container {
  // min-height: 800px;
  margin-top: 3rem;
  margin-bottom: 3rem;
  // padding: 15px;
  // padding-top: 30px;
  // padding-bottom: 80px;
  // padding-right: 0px;

  // .container {
  //   padding: 15px;
  //
  //   @media screen and (min-width: $desktop) {
  //     padding: 50px;
  //   }
  // }

  .title {

    padding: 15px;

    a {
      color: $color-darkbrown;
    }
    font-family: $font-family-title;
    text-transform: uppercase;

    // padding-left: 0px;
    //
    // @media screen and (min-width: $desktop) {
    //   padding-left: 10px;
    // }
  }

  .focus-image-wrapper {
    border-radius: 0px;
    box-shadow: 0 0 0, 0 0 0 0;
    margin: 4px;

    @media screen and (min-width: $desktop) {
      margin: 8px;
    }
  }
}

.lb-image {
  width: auto !important
}

// .masonry-container {
//   margin: 0 auto;
// }
//
// .masonry-item {
//   margin: 0 auto 0 auto;
//   padding: 0px;
//   padding-left: 0px;
//   padding-right: 15px;
//   padding-bottom: 15px;
//   width: 50%;
//
//   @media screen and (min-width: $desktop) {
//     padding-left: 10px;
//     padding-right: 10px;
//   }
//
//   @media screen and (min-width: $tablet) {
//     width: 33.33%;
//   }
//
//   @media screen and (min-width: $desktop) {
//     width: 33.33%;
//   }
//
//   .card {
//     border-radius: 0px;
//     box-shadow: 0 0 0, 0 0 0 0;
//     overflow: hidden;
//
//     .card-header, .card-image {
//       margin: 15px;
//       img {
//         border-radius: 0px;
//         transition: all .3s ease;
//
//         &:hover {
//           transform: scale(1.2);
//         }
//       }
//     }
//
//     .card-content {
//       display: none;
//     }
//   }
// }
//
// .load-more {
//   margin-top: 50px;
//   text-align: center;
//
//   .button, .ended {
//     margin: 0 auto;
//     border: 0px;
//     background-color: transparent;
//     color: #999999;
//
//     a {
//       color: $color-gray;
//
//       &:hover {
//         color: $color-gray-mid;
//       }
//     }
//
//     &.is-loading:after {
//       border-color: #999999;
//       border-right-color: transparent;
//       border-top-color: transparent;
//     }
//   }
// }

</style>



// WEBPACK FOOTER //
// InstagramSection.vue?533959dc